// This code should be added to the head of the document according to the Clarity documentation
// But this way we can use the process.env.NODE_ENV variable to load the correct Clarity project
// This also explains why this is a .js file instead of a .ts file
const startClarity = () => {
  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(
    window,
    document,
    "clarity",
    "script",
    process.env.NODE_ENV === "production" ? "jf2ec3twg8" : "jf24jsnaj8"
  );
};

if (import.meta.env.PROD) startClarity();
